/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Status, getState, track, ajax, } from '../../../twd'

const state = getState('order-ticket.cusip-search', {})

export const useCusipSearch  = ({keyword, isQrt}) => {
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')
    const [searchResults, setSearchResults] = React.useState([])

    const timerId = React.useRef()
    const lastKeyword = React.useRef(state.value.lastKeyword)
    const lastAbort = React.useRef()

    React.useEffect(() => {
        if (isQrt) return

        if (timerId.current) {
            clearTimeout(timerId.current)
            timerId.current = 0
        }

        var dismounted = false

        timerId.current = setTimeout(async () => {
            if (!keyword) return

            if (lastKeyword.current === keyword && searchResults.length>0) {
                return
            }

            state.set({lastKeyword: keyword})
            setStatus(Status.LOADING)
            setError('')
            lastKeyword.current = keyword

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let { data, abort } = await ajax({
                    url: '/esb/portfolio/securitysuggestions',
                    method: 'GET',
                    params: {
                        keyword: keyword.trim(),
                        page:1,
                        start:0,
                        limit:10
                    }
                })

                lastAbort.current = abort
                let a = await data
                if (dismounted) return

                track('Bond Resource Center Search', { search_term: keyword.trim() })

                let rs = (a.securities || []).slice(0, 10).map(a => {
                    a.searchParams = {
                        holdCusip:[a.cusip],
                        holdIdentifierLabel: "holdCusip",
                        holdIdentifiers:[a.cusip],
                        offeringType: ['ask-side'],
                    }
                    return a
                })

                if (rs.length===0) throw new Error('empty-result')

                setSearchResults(rs)
                setStatus(Status.LOADED)

            } catch(e) {
                if (dismounted) return

                setSearchResults([])
                setError(`
                    There are no results that match your search for
                    <span class="text-bold"><u>${keyword}</u></span>.
                    Please review your search criteria and try again.
                `)

                setStatus(Status.FAILED_TO_LOAD)
            }
        }, 500)

        return () => {
            dismounted = true

            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
            if (timerId.current) {
                clearTimeout(timerId.current)
                timerId.current = 0
            }
        }

    }, [keyword])

    return { status, error, keyword, searchResults }
}
